module.exports = __webpack_public_path__ + "img/if_10.4aed986d.png";